/**
 * Minimal client-side ULID generator (Crockford base32, 26 chars).
 *
 * Used to mint an `impressionUlid` that correlates a prompt impression with the
 * answer and recommendation that follow. The server (webby-server) generates
 * ULIDs with `ulidx`; we avoid pulling that dependency into the browser bundle
 * for a single id, so this is a small, dependency-free equivalent. The value is
 * only ever used as an opaque correlation key, never parsed.
 */

// Crockford's base32 alphabet (excludes I, L, O, U to avoid ambiguity).
const ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const ENCODING_LEN = ENCODING.length;
const TIME_LEN = 10;
const RANDOM_LEN = 16;

function encodeTime(time: number): string {
    let now = time;
    let str = "";
    for (let i = TIME_LEN - 1; i >= 0; i -= 1) {
        const mod = now % ENCODING_LEN;
        str = ENCODING[mod] + str;
        now = (now - mod) / ENCODING_LEN;
    }
    return str;
}

function encodeRandom(): string {
    let str = "";
    for (let i = 0; i < RANDOM_LEN; i += 1) {
        str += ENCODING[Math.floor(Math.random() * ENCODING_LEN)];
    }
    return str;
}

export function ulid(): string {
    return encodeTime(Date.now()) + encodeRandom();
}

export default ulid;
